import styled, { css } from "styled-components"

export const Container = styled.button`
    padding: 1rem;
    background: ${props => props.background ? props.background : 'var(--mainTheme)'};
    color: ${props => props.color ? props.color : '#FFF'};
    border-radius: 0.5rem;
    transition: filter 0.2s ease;
    border: none;
    width: 100%;
    font-size: 1.2rem;

    display: flex;
    align-items: center;

    display: flex;
    justify-content: center;

    svg{
        font-size: 1.1rem;
        margin-right: 0.5rem;
    }

    &:hover{
        filter: brightness(0.9);
    }
   
    @media (min-width: 960px){
        cursor: pointer;
    }
     
     
     ${({ isLoading }) => isLoading && css`
            opacity: 0.5;
            pointer-events: none;
     `}
`